module.exports = __webpack_public_path__ + "02ae0cd112da0a49fe79923f5ff2ec42.png";